import React, { useState, useEffect } from 'react';
import { Flame, Sparkles } from 'lucide-react';
import SurpriseDropModal from './SurpriseDropModal';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StreakCard = () => {
  const [streak, setStreak] = useState(null);
  const [surpriseDrop, setSurpriseDrop] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('hibff_auth_token') || sessionStorage.getItem('hibff_auth_token');
    fetch(`${API_URL}/api/engagement/streaks`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(data => {
        setStreak(data);
        if (data?.surprise_drop) setSurpriseDrop(data.surprise_drop);
      }).catch(() => {});
  }, []);

  if (!streak) return null;

  const progress = streak.next_reward_at ? (streak.current_streak / streak.next_reward_at) * 100 : 100;
  const isMilestone = [7, 14, 30, 60, 90].includes(streak.current_streak);

  return (
    <>
      <div className={`bg-gradient-to-r ${isMilestone ? 'from-amber-100 to-yellow-100 border-amber-300' : 'from-orange-50 to-amber-50 border-orange-200'} rounded-xl p-5 border`} data-testid="streak-card">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className={`w-9 h-9 rounded-lg ${isMilestone ? 'bg-amber-200' : 'bg-orange-100'} flex items-center justify-center`}>
              <Flame size={20} className={isMilestone ? 'text-amber-600' : 'text-orange-500'} />
            </div>
            <div>
              <p className="text-sm font-bold text-gray-900">Daily Streak</p>
              <p className="text-xs text-gray-500">
                {isMilestone ? (
                  <span className="flex items-center gap-1 text-amber-600 font-semibold">
                    <Sparkles size={10} /> Milestone reached!
                  </span>
                ) : 'Keep it going!'}
              </p>
            </div>
          </div>
          <div className="text-right">
            <p className={`text-2xl font-black ${isMilestone ? 'text-amber-600' : 'text-orange-500'}`}>{streak.current_streak}</p>
            <p className="text-[10px] text-gray-400 uppercase tracking-wider">days</p>
          </div>
        </div>
        {streak.next_reward_at && (
          <div>
            <div className="flex justify-between text-xs text-gray-500 mb-1">
              <span>Next reward at {streak.next_reward_at} days</span>
              <span>{Math.min(100, Math.round(progress))}%</span>
            </div>
            <div className="h-2 bg-orange-100 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-orange-400 to-amber-400 rounded-full transition-all" style={{ width: `${Math.min(100, progress)}%` }} />
            </div>
          </div>
        )}
        {streak.longest_streak > streak.current_streak && (
          <p className="text-xs text-gray-400 mt-2">Personal best: {streak.longest_streak} days</p>
        )}
      </div>

      <SurpriseDropModal drop={surpriseDrop} onClose={() => setSurpriseDrop(null)} />
    </>
  );
};

export default StreakCard;
